import { Link } from 'react-router'
import { Button } from '@/components/ui/button'
import { EmptyState } from '@/components/data/states'

export default function NotFoundPage() {
  return (
    <div className="panel">
      <EmptyState
        title="There's nothing at this address"
        action={
          <Button asChild variant="outline" size="sm">
            <Link to="/">Go to the overview</Link>
          </Button>
        }
      >
        The page may have moved, or the link is mistyped.
      </EmptyState>
    </div>
  )
}
